import React from "react";
import agendaImg from "../../img/accueil_concept4.png";

function Agenda() {
  return (
    <div className="w-full bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg bg-orange-50 max-h-[600px]">
            <img
              src={agendaImg}
              alt="Agenda Mood"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-col gap-4">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
              Aucun événement prévu pour le moment!
            </h1>
            <p className="text-slate-700 leading-relaxed">
              Mais on travaille activement pour pouvoir vous proposer des choses rapidements!
              </p>
              <p className="text-slate-700 leading-relaxed">
                See you soon !
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Agenda;
